import React, { useState, useEffect } from "react"
import axios from "axios"
import { useNavigate, Link } from "react-router-dom"
import Card from 'react-bootstrap/Card'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import { FaBars, FaPlus } from 'react-icons/fa'
import { apiURL, sitePath, filesURL } from 'config/globals'
import Topbar from 'components/Topbar'
import Sidebar from 'components/Sidebar'
import Breadcrumbs from 'components/Breadcrumbs'
import Footer from 'components/Footer'
import { checkAuth } from 'utils/Auth'

const Museums = () => {
    const [currentUser, setCurrentUser] = useState(false)
    const [museums, setMuseums] = useState([])
    const [filteredRows, setFilteredRows] = useState([])
    const [searchValue, setSearchValue] = useState("")
    const navigate = useNavigate()
    
    useEffect(() => {
        const start = async () => {
            setCurrentUser(await checkAuth(navigate))
            await getMuseums()
        }
        start()
    }, [])

    useEffect(() => {
        search(searchValue)
    }, [searchValue])

    const getMuseums = async () => {
        const response = await axios.get(`${apiURL}/get-museums`)
        const rows = response.data.rows || []
        setMuseums(rows)
        setFilteredRows(rows)
    }

    const search = (str) => {
        if (!museums || !museums.length) {
            return
        }

        if (!str) {
            setFilteredRows(museums)
            return
        }

        const lowerValue = removeAccents(str.toLowerCase())
        const filteredRows = museums.filter(row => removeAccents(Object.values(row).join('').toLowerCase()).includes(lowerValue))
        setFilteredRows(filteredRows)
    }

    const removeAccents = (str) => {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    }

    const newMuseum = () => {
        navigate(`/museums/new`)
    }

    const viewMuseum = (id) => {
        const museum = museums.find(x => x.id === id)
        navigate(`/museums/${museum.id}`)
    }

    return (
        <>
            <Topbar currentUser={currentUser} />
            <Sidebar selectedItem="museums" currentUser={currentUser} />
            <main>
                <Breadcrumbs items={[['Museums']]} />
                <div className="btn-toggle">
                    <FaBars />
                </div>
                <header>
                    <div className="float-start">
                        <h1>Museums</h1>
                    </div>
                    <Button variant="primary" className="float-end" onClick={newMuseum}>
                        <FaPlus /> New Museum
                    </Button>
                </header>
                {filteredRows
                    ? <>
                        <Form.Control
                            placeholder="Museum quick search"
                            onChange={e => setSearchValue(e.target.value)}
                            className="mb-4"
                        />
                        <Row>
                            {filteredRows.map(museum =>
                                <Col md="6" lg="4" key={`col-${museum.id}`}>
                                    <Card className="mb-4 clickable" onClick={() => viewMuseum(museum.id)}>
                                        <Card.Img
                                            variant="top"
                                            src={`${filesURL}/${museum.mainImage}`}
                                        />
                                        <Card.Body>
                                            <Card.Title>{museum.name}</Card.Title>
                                            <Card.Text>{museum.description.split('\n\n')[0]}</Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )}
                        </Row>
                      </>
                    : <>No museums found.</>
                }
                <Footer user={currentUser} />
            </main>
        </>
    )
}

export default Museums